
import React, { useState } from 'react';
// import { useHistory } from 'react-router-dom';
import { Row, Table, Button, Col, Form, Modal, message, Tag } from 'antd';
import { SaveOutlined } from '@ant-design/icons'
import CategoryUtils from '../../common/CategoryUtils';
import BrandSelect from '../../components/BrandSelect';
import { getSizeChartList, copySizeCharts, deleteSizeChartById } from '@services/sizeChartsService';
import CategorySelect from '@components/CategorySelect';
import bxlUtils from 'bxl-utils';
import './index.scss';

const { confirm } = Modal;
const PAGE_SIZE = 10;

function SizeCharts() {
    const [form] = Form.useForm()
    const [tableLoading, setTableLoading] = useState(false);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [brandList, setBrandList] = useState([]);
    const [list, setList] = useState([]);
    const [categoryNameMap, setCategoryNameMap] = useState({});
    const [total, setTotal]: [any, any] = useState();
    const cMap = {};
    // const history = useHistory()

    function onEdit(r: any) {
      const queryParams = {
        b: r?.brand,
        cIds: r?.categoryIds
      }
      window.open(`/size-chart-editor/${r?.id || ''}?${bxlUtils.uri.stringify(queryParams)}`, '__blank')
    }

    const columns = [
        {
            title: '品牌ID',
            dataIndex: 'brand',
            key: 'brand',
            width: 250,
        }, {
            title: '品牌名称',
            dataIndex: 'brandName',
            key: 'brandName',
            width: 150,
        }, {
            title: '类目ID',
            key: 'categoryIds',
            width: '300px',
            render: (record) => {
                return (
                    <div>
                        {
                            record.categories ? (record.categories.map(c => <Tag key={c.id}>{categoryNameMap[c.id]}</Tag>)) : <Tag>{categoryNameMap[record.category]}</Tag>
                        }
                    </div>
                )
            }
        }, {
            title: '操作',
            key: 'action',
            width: '250px',
            render: (record) => (
                <Row>
                    <Col span={8}>
                        <Button type="primary" onClick={() => onEdit(record)}>编辑</Button>
                    </Col>
                    <Col span={8}>
                        <Button danger onClick={() => handleDelete(record)}>删除</Button>
                    </Col>
                </Row>
            )
        }
    ];

    function handleDelete(record) {
        const { id, categories, brandName } = record;
        confirm({
            title: '删除',
            content: `确认删除${brandName}品牌下${categories.map(c => c.id)}分类的尺码表 ${id} 吗？`,
            okText: '确认',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
                deleteSizeChartById(id)
                    .then(res => {
                        message.success('删除成功');
                        getList();
                    }).catch(err => {
                        message.error('删除失败');
                    })
            },
            onCancel() {
              
            },
        });
    }

    function handleSearch() {
        getList();
    }

    function onCategoryLoad(data) {
      CategoryUtils.saveCategoryTree(data)
      data.children.push({
        category: {
            id: 'other',
            displayTerm: 'other',
            term: 'other',
        }
      })
      getCategoryFullName(data.children)
      setCategoryNameMap(cMap)
    }

    function getCategoryFullName(children, parentName?: string) {
        if(children && children.length > 0) {
            children.forEach((item) => {
                if(!cMap[item.category.id]) {
                    cMap[item.category.id] = `${item.category.id}-${parentName ? parentName + '-' : ''}${item.category.displayTerm}(${item.category.term})`;
                }
                if(item.children &&  item.children.length > 0) {
                    getCategoryFullName(
                        item.children,
                        `${parentName ? parentName + '-' : ''}${item.category.displayTerm}`
                    )
                }
            })
        }
    }

    function getList(from = 0) {
        setTableLoading(true);
        form.validateFields().then((values) => {
            const categoryId = values?.categoryId;
            getSizeChartList({
                brandId: brandList,
                categoryId: categoryId || null,
                from: from,
                to: from + PAGE_SIZE
            }).then(res => {
                const { data } = res;
                setList(data?.results || []);
                setTotal(data.total);
                setTableLoading(false);
            }).catch(err => {
                setTableLoading(false);
            })
        })
    }

    function handleCurrentPageChange(current) {
        getList((current - 1) * PAGE_SIZE);
    }

    return (
        <div className='p-size-charts'>
            <Form layout='inline' name='size-chart' form={form}>
                <Form.Item label="Brand">
                    <BrandSelect
                        value={brandList}
                        mode='multiple'
                        placeholder="Please select brand"
                        onChange={(e) => setBrandList(e)}
                    />
                </Form.Item>
                <Form.Item label="Category" name="categoryId">
                    <CategorySelect onCategoriesLoad={onCategoryLoad} />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" onClick={handleSearch} disabled={!brandList || !brandList.length}>
                        查询
                    </Button>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" ghost onClick={() => setDialogVisible(true)}>
                        复制
                    </Button>
                </Form.Item>
                <Form.Item>
                    <Button icon={<SaveOutlined />} onClick={onEdit}>
                        新建
                    </Button>
                </Form.Item>
            </Form>
            <Table
                style={{ backgroundColor: '#ffffff' }}
                tableLayout='fixed'
                columns={columns}
                dataSource={list}
                loading={tableLoading}
                rowKey={(record: any) => record.id}
                pagination={{
                    pageSize: PAGE_SIZE,
                    total: total,
                    showQuickJumper: true,
                    onChange: handleCurrentPageChange,
                    style: {
                        paddingRight: '20px'
                    }
                }}
            />
            <SizeChartDialog
                dialogVisible={dialogVisible}
                handleDialogClose={() => setDialogVisible(false)}
            />
        </div>
    )
}

function CopyModal(props) {
    const [form] = Form.useForm();
    const { dialogVisible, handleDialogClose } = props;
    const [editBrand, setEditBrand] = useState<string>('');
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 12 },
        },
    };

    function handleSubmit() {
        form.validateFields().then((values) => {
            const { sourceCategory, newCategories } = values;
            copySizeCharts(editBrand, sourceCategory, newCategories)
                .then(_ => {
                    message.success('复制成功');
                    handleClose();
                })
                .catch(err => message.error(err?.response?.data?.resource || '复制失败'))
        })
    }

    function handleClose() {
        setEditBrand('');
        handleDialogClose && handleDialogClose();
    }

    return (
        <Modal
            visible={dialogVisible}
            okText="复制"
            cancelText="取消"
            onCancel={handleClose}
            onOk={handleSubmit}
            destroyOnClose={true}
            title="批量复制尺码表"
        >
            <Form {...formItemLayout} name='size-chart-dialog' form={form}>
                <Form.Item label="品牌">
                    <BrandSelect
                        value={editBrand}
                        placeholder="Please select brand"
                        onChange={(e) => setEditBrand(e)}
                    />
                </Form.Item>
                <Form.Item label="原类目ID" name="sourceCategory">
                  <CategorySelect />
                </Form.Item>
                <Form.Item label="新类目ID" name="newCategories">
                  <CategorySelect multiple />
                </Form.Item>
            </Form>
        </Modal>
    )
}

const SizeChartDialog = CopyModal

export default SizeCharts